/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { getImportLogDetail } from "./ImportLogsHelper";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Spin from "../../common/Spin";
import { convertDateString, formatNumber } from "../../common/Misc";
import BootstrapTable from "react-bootstrap-table-next";

const ImportLogDetail = ({
  //data,
  importLogId,
  toggleShowModal,
  importLogModal,
  projectId,
}) => {
  const [importLogDetail, setImportLogDetail] = useState(null);
  const [contactDetail, setContactDetail] = useState(null);
  const [creditNoteDetail, setCreditNoteDetail] = useState([]);
  const [paymentDetail, setPaymentDetail] = useState([]);
  //   const [verifiedByUser, setVerifiedByUser] = useState(null);
  //   const [statementData, setStatementData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const importLogRes = await getImportLogDetail(importLogId, projectId);
      if (importLogRes) {
        let contactDetails = importLogRes?.Contact
          ? JSON.parse(importLogRes?.Contact)
          : "";
        let creditNotes = importLogRes?.CreditNotes
          ? JSON.parse(importLogRes?.CreditNotes)
          : [];
        let payments = importLogRes?.Payments
          ? JSON.parse(importLogRes?.Payments)
          : [];
        setContactDetail(contactDetails);
        setCreditNoteDetail(creditNotes);
        setImportLogDetail(importLogRes);
        setPaymentDetail(payments);
      }

      setLoading(false);
    }
    fetchData();
  }, [importLogId, projectId]);

  const Status = (id, description) => {
    if (id === 0 && description) {
      return `Contact data not imported because ${description}`;
    } else {
      if (id === 1) {
        return "Contact Created";
      } else {
        return "Contact Updated";
      }
    }
  };

  const creditColumns = [
    {
      dataField: "date",
      text: "Date",
      //   sort: true,
    },
    {
      dataField: "total",
      text: "Total",
      //   sort: true,
    },
  ];

  const creditNoteGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: creditNoteDetail[i]?.id,
        date: creditNoteDetail[i]?.Date
          ? convertDateString(creditNoteDetail[i]?.Date)
          : "-",
        total: creditNoteDetail[i]?.Total
          ? `$${formatNumber(creditNoteDetail[i]?.Total)}`
          : "-",
      });
    }
    return items;
  };
  const creditNoteData = creditNoteGenerator(creditNoteDetail?.length);

  const paymentColumns = [
    {
      dataField: "date",
      text: "Date",
      //   sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      //   sort: true,
    },
  ];

  const paymentGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: paymentDetail[i]?.id,
        date: paymentDetail[i]?.Date
          ? convertDateString(paymentDetail[i]?.Date)
          : "-",
        amount: paymentDetail[i]?.Amount
          ? `$${formatNumber(paymentDetail[i]?.Amount)}`
          : "-",
      });
    }
    return items;
  };
  const paymentData = paymentGenerator(paymentDetail?.length);
  
  const getVerifiedDateTime = (date) => {
    return moment(date).format("DD-MM-YYYY HH:mm:ss").toString();
  };

  return (
    <>
      <Modal
        size="lg"
        show={importLogModal}
        onHide={toggleShowModal}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Payment Claim Details
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Spin />
          ) : (
            <>
              <div className="modal-content">
                <h3>Payment Claim Details</h3>
                <div className="modal-content-details">
                  {/* <div className="modal-content-left"> */}
                  <p>
                    <strong>Payment Claim By:</strong>{" "}
                    {contactDetail?.Name
                      ? `${contactDetail?.Name} ${
                          contactDetail?.FirstName && contactDetail?.LastName
                            ? "(" +
                              contactDetail?.FirstName +
                              " " +
                              contactDetail?.LastName +
                              ")"
                            : !contactDetail?.FirstName &&
                              contactDetail?.LastName
                            ? "(" + contactDetail?.LastName + ")"
                            : ""
                        }`
                      : contactDetail?.FirstName && contactDetail?.LastName
                      ? contactDetail?.FirstName + " " + contactDetail?.LastName
                      : !contactDetail?.FirstName && contactDetail?.LastName
                      ? contactDetail?.LastName
                      : ""}
                  </p>
                  <p>
                    <strong>Invoice/Claim Number:</strong>{" "}
                    {importLogDetail?.InvoiceNumber
                      ? importLogDetail?.InvoiceNumber
                      : "-"}
                  </p>
                  {/* </div> */}
                  {/* <div className="modal-content-right"> */}
                  <p>
                    <strong>Invoice/Claim Date:</strong>{" "}
                    {importLogDetail?.Date ? importLogDetail?.Date : "-"}
                  </p>
                  <p>
                    <strong>Due Date:</strong>{" "}
                    {importLogDetail?.DueDate ? importLogDetail?.DueDate : "-"}
                  </p>
                  <p>
                    <strong>Claimed Amount (Ex. GST):</strong>{" "}
                    {importLogDetail?.Total
                      ? `$${formatNumber(
                          Number(
                            formatNumber(
                              Number(importLogDetail?.Total)
                            ).replace(/,/g, "") / 1.1
                          )
                        )}`
                      : "$0.00"}
                  </p>
                  <p>
                    <strong>Claimed Amount (Inc. GST):</strong>{" "}
                    {importLogDetail?.Total
                      ? `$${formatNumber(Number(importLogDetail?.Total))}`
                      : "$0.00"}
                  </p>
                  <p>
                    <strong>Amount Credited:</strong>{" "}
                    {importLogDetail?.AmountCredited
                      ? `$${formatNumber(
                          Number(importLogDetail?.AmountCredited)
                        )}`
                      : "$0.00"}
                  </p>
                  <p>
                    <strong>Amount Due:</strong>{" "}
                    {importLogDetail?.AmountDue
                      ? `$${formatNumber(Number(importLogDetail?.AmountDue))}`
                      : "$0.00"}
                  </p>
                  <p>
                    <strong>Amount Paid:</strong>{" "}
                    {importLogDetail?.AmountPaid
                      ? `$${formatNumber(Number(importLogDetail?.AmountPaid))}`
                      : "$0.00"}
                  </p>
                </div>
              </div>
              {
                <div className="modal-content">
                  <h3>Credit Note & Payment</h3>
                  <div className="modal-content-details credit-note-payment">
                    <p>
                      <strong>Credit Note</strong>{" "}
                      <BootstrapTable
                        keyField="id"
                        remote
                        data={creditNoteData}
                        columns={creditColumns}
                        noDataIndication="No Data Found"
                      />
                    </p>
                    <p>
                      <strong>Payment</strong>{" "}
                      <BootstrapTable
                        keyField="id"
                        remote
                        data={paymentData}
                        columns={paymentColumns}
                        noDataIndication="No Data Found"
                      />
                    </p>
                  </div>
                </div>
              }

              <div className="modal-content">
                <h3>Sync</h3>
                <div className="modal-content-details">
                  <p>
                    <strong>Import From:</strong>
                    {importLogDetail?.import_from
                      ? importLogDetail?.import_from
                      : "BuildTrust"}
                  </p>
                  <p>
                    <strong>Import Date:</strong>
                    {importLogDetail?.created_at
                      ? moment(
                          importLogDetail?.created_at,
                          "DD-MM-YYYY HH:mm:ss"
                        ).format("DD-MM-YYYY")
                      : "-"}
                  </p>
                  <p>
                    <strong>Imported by:</strong>
                    {importLogDetail?.imported_by
                      ? importLogDetail?.imported_by?.first_name &&
                        importLogDetail?.imported_by?.last_name
                        ? importLogDetail?.imported_by?.first_name +
                          " " +
                          importLogDetail?.imported_by?.last_name
                        : importLogDetail?.imported_by?.first_name
                        ? importLogDetail?.imported_by?.first_name
                        : importLogDetail?.imported_by?.last_name
                        ? importLogDetail?.imported_by?.last_name
                        : "-"
                      : "-"}
                  </p>
                  <p>
                    <strong>Last synchronised time:</strong>{" "}
                    {importLogDetail?.last_sync_date
                      ? getVerifiedDateTime(importLogDetail?.last_sync_date)
                      : "-"}
                  </p>
                  <p>
                    <strong>Note:</strong>
                    {importLogDetail?.status == null ||
                    importLogDetail?.status == ""
                      ? "-"
                      : Status(
                          parseInt(importLogDetail?.status),
                          importLogDetail?.message
                        )}
                  </p>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImportLogDetail;
